'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _colmo = require('../../mixins/colmo');

var _colmo2 = _interopRequireDefault(_colmo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var icon = require('../setting/icon.base64');
var PLACEHOLDERIMAGE = icon['ic_img_null@2x'];
var modal = weex.requireModule('modal');
exports.default = {
  mixins: [_colmo2.default],
  props: {
    sliderStyle: {
      type: Object,
      default: function _default() {
        return {
          width: '686px',
          height: '280px',
          position: 'relative'
        };
      }
    },
    indicatorStyle: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    interval: {
      type: Number,
      default: 3000
    },
    autoplay: {
      type: Boolean,
      default: true
    },
    infinite: {
      type: Boolean,
      default: true
    },
    imgResize: {
      type: String,
      default: 'cover'
    },
    imgWidth: {
      type: String,
      default: '686px'
    },
    divLeft: {
      type: String,
      default: '32px'
    },
    imgHeight: {
      type: String,
      default: '280px'
    },
    showIndicator: {
      type: Boolean,
      default: true
    },
    phImgUrl: {
      type: String,
      default: PLACEHOLDERIMAGE
    },
    imageBgColor: {
      type: String,
      default: '#f2f2f2'
    }
  },
  data: function data() {
    return {
      slItems: [],
      active: 0
    };
  },
  created: function created() {
    if (this.items.length > 10) {
      this.slItems.splice(0);
      this.slItems = this.items.slice(0, 10);
    } else if (this.items.length <= 10) {
      this.slItems.splice(0);
      this.slItems = this.items.slice(0);
    }
  },

  methods: {
    imgClicked: function imgClicked(target, index) {
      this.$emit('dofSwiperClicked', { target: target, index: index });
    },
    change: function change(val) {
      this.active = val.index;
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/script-loader.js!./~/babel-loader/lib!./~/weex-vue-loader/lib/selector.js?type=script&index=0!./packages/dof-swiper/index.vue
// module id = 400
// module chunks = 0 1